import { act } from "react";
import { TYPE } from "../actions/types";

const intialState = {
    getOffersApiResponse: {},
    createAndUpdateOfferApiRes: {},
    createAndUpdateOfferApiLoader: false,
    reOrderSearchOfferApiRes: {},
    offersApiLoadingState: true,
    updateSearchOfferStatusRes: {}
};

export default function (state = intialState, action) {
    switch (action.type) {
        case TYPE.GET_SEARCH_OFFER:
            state.getOffersApiResponse = action.payload;
            state.offersApiLoadingState = false
            return {
                ...state,
                response: action.payload
            };
        case TYPE.CREATE_SEARCH_OFFER:
            state.createAndUpdateOfferApiRes = action.payload;
            state.createAndUpdateOfferApiLoader = false
            return { ...state, response: action.payload }
        case TYPE.UPDATE_SEARCH_OFFER:
            state.createAndUpdateOfferApiRes = action.payload;
            state.createAndUpdateOfferApiLoader = false
            return { ...state, response: action.payload }
        case TYPE.REORDER_SEARCH_OFFER:
            state.reOrderSearchOfferApiRes = action.payload
            return { ...state, response: action.payload }
        case TYPE.UPDATE_SEARCH_OFFER_STATUS:
            state.updateSearchOfferStatusRes = action.payload
            return { ...state, response: action.payload }
        case "clear_active_domain_api_responses":
            state.getOffersApiResponse = {};
            state.offersApiLoadingState = true
            return { ...state, response: action.payload };
        case "clear_update_create_offer_responses":
            state.createAndUpdateOfferApiRes = {}
            return { ...state, response: action.payload }
        case "handle_update_create_catch_error_cases":
            state.createAndUpdateOfferApiRes = {
                status: "ERROR",
                msg: "Some Error Occured"
            }
            state.createAndUpdateOfferApiLoader = false
            return { ...state, response: action.payload };
        case "clear_reOrderSearchOffer_api_response":
            state.reOrderSearchOfferApiRes = {}
            return { ...state, response: action.payload }
        case "handle_catch_block_error_cases":
            state.getOffersApiResponse = {
                status: "ERROR",
                msg: "Some Error Occured"
            }
            state.offersApiLoadingState = false
            return { ...state, response: action.payload };
        case "clear_update_global_offers_status_res":
            state.updateSearchOfferStatusRes = {}
            return { ...state, response: action.payload }
        default:
            return state;
    }
}
